//REGISTER
export const POST_REGISTER = "/register";

//LOGIN
export const POST_LOGIN = "/login";
export const POST_PASSWORD_FORGET = "/forgot-password";
export const POST_PASSWORD_RESET = "/reset-password";
export const POST_LOGOUT = "/logout";
export const UPDATE_PASSWORD = "/user/password";

//PROFILE
export const POST_EDIT_PROFILE = "/user";

// ------------------------- WEB -------------------------
// Shop Menu
export const GET_WEB_SHOP = "/web/shop";
export const GET_WEB_DETAIL_MENU = (menuId: string) => `/web/menu/${menuId}`;
export const GET_MENUS = "/menu";
export const CREATE_MENU = "/menu";
export const MENU = (menuId: string | number) => `/menu/${menuId}`;
export const MENU_STATUS = (menuId: string | number) => `/menu/${menuId}/status`;
export const GET_MENU_CATEGORIES = "/menu/categories";
export const CREATE_MENU_CATEGORY = "/menu/categories";
export const MENU_CATEGORY = (categoryId: string | number) => `/menu/categories/${categoryId}`;
export const REORDER_MENU_CATEGORIES = "/menu/categories/sort-order";
export const GET_MENU_OPTIONS = "/menu/options";
export const CREATE_MENU_OPTION = "/menu/options";
export const MENU_OPTION = (optionId: string | number) => `/menu/options/${optionId}`;
export const MENU_OPTION_VALUES = (optionId: string | number) =>
    `/menu/options/${optionId}/values`;
export const MENU_OPTION_VALUE = (optionId: string | number, valueId: string | number) =>
    `/menu/options/${optionId}/values/${valueId}`;
export const IMPORT_MENU = "/menu/import";
export const SHOP = "/my-shop";
export const SHOP_WIFI = "/my-shop/wifi";
export const CREATE_OWN_SHOP = "/shop/create-own";
export const JOIN_SHOP_BY_INVITE = "/shop/join-by-invite";
export const SHOP_INVITE_CODE = "/shop/invite-code";
export const SHOP_INVITE_REGENERATE = "/shop/invite-code/regenerate";
export const GET_PLANS = "/plans";
export const GET_PLAN_DETAIL = (planId: string | number) => `/plans/${planId}`;

// Order
export const GET_ORDERS = "/order";
export const GET_ORDER_DETAIL = (orderId: string | number) => `/order/${orderId}`;
export const GET_DRAFT_ORDERS = "/order?status=draft";
export const GET_UNCLAIMED_ORDERS = "/order/unclaimed";
export const CREATE_ORDER = "/order";
export const CREATE_WEB_ORDER = "/web/order";
export const WEB_SERVICE_CALL = "/web/service-call";
export const START_ORDER = (orderId: string | number) => `/order/${orderId}/start`;
export const COMPLETE_ORDER = (orderId: string | number) => `/order/${orderId}/complete`;
export const DELETE_ORDER = (orderId: string | number) => `/order/${orderId}`;
export const UPDATE_ORDER_STATUS = (orderId: string | number) => `/order/order-status/${orderId}`;
export const ORDER_ITEMS = (orderId: string | number) => `/order/${orderId}/items`;
export const ORDER_ITEM = (orderId: string | number, itemId: string | number) =>
    `/order/${orderId}/items/${itemId}`;
export const ORDER_MARK_UNCLAIMED = (orderId: string | number) => `/order/${orderId}/unclaimed`;
export const ORDER_UNCLAIMED_RESOLVE = (orderId: string | number) => `/order/${orderId}/unclaimed/resolve`;
export const GET_PAID_ORDERS = (shopId: string | number) => `/order/paid-and-not-done/${shopId}`;
export const GET_UNPAID_ORDERS = (shopId: string | number) => `/order/not-paid-and-not-done/${shopId}`;
export const GET_IN_PROCESS_ORDERS = (shopId: string | number) => `/order/in-process/${shopId}`;
export const GET_COMPLETED_ORDERS = (shopId: string | number) => `/order/complete/${shopId}`;

// Tables
export const GET_TABLES = "/web/tables";
export const GET_SHOP_TABLES = "/tables";
export const CREATE_TABLE = "/tables";
export const TABLE = (tableId: string | number) => `/tables/${tableId}`;

// Zones
export const GET_ZONES = "/zones";
export const CREATE_ZONE = "/zones";
export const ZONE = (zoneId: string | number) => `/zones/${zoneId}`;

// Notifications
export const NOTIFICATIONS = "/notifications";
export const NOTIFICATION_MARK_READ = (notificationId: string | number) =>
    `/notifications/${notificationId}/read`;
export const NOTIFICATIONS_MARK_READ_ALL = "/notifications/read-all";
export const NOTIFICATIONS_UNREAD_COUNT = "/notifications/unread-count";
export const NOTIFICATION_SETTINGS = "/notification-settings";
export const WEBPUSH_SUBSCRIPTIONS = "/webpush/subscriptions";
export const FEEDBACK = "/feedback";

// Reports
export const REPORT_REVENUE_BY_DAY_LAST_SEVEN = (shopId: string | number) =>
    `/report/revenue-by-day-last-7-days/${shopId}`;
export const REPORT_REVENUE_BY_HOUR_TODAY = (shopId: string | number) => `/report/revenue-by-hour-today/${shopId}`;
export const REPORT_REVENUE_BY_HOUR_YESTERDAY = (shopId: string | number) =>
    `/report/revenue-by-hour-yesterday/${shopId}`;
export const REPORT_REVENUE_BY_DAY_THIS_MONTH = (shopId: string | number) =>
    `/report/revenue-by-day-this-month/${shopId}`;
export const REPORT_REVENUE_BY_DAY_LAST_MONTH = (shopId: string | number) =>
    `/report/revenue-by-day-last-month/${shopId}`;
export const REPORT_ORDER_BY_DAY_LAST_SEVEN = (shopId: string | number) =>
    `/report/order-quantity-by-day-last-7-days/${shopId}`;
export const REPORT_ORDER_BY_HOUR_TODAY = (shopId: string | number) =>
    `/report/order-quantity-by-hour-today/${shopId}`;
export const REPORT_ORDER_BY_HOUR_YESTERDAY = (shopId: string | number) =>
    `/report/order-quantity-by-hour-yesterday/${shopId}`;
export const REPORT_ORDER_BY_DAY_THIS_MONTH = (shopId: string | number) =>
    `/report/order-quantity-by-day-this-month/${shopId}`;
export const REPORT_ORDER_BY_DAY_LAST_MONTH = (shopId: string | number) =>
    `/report/order-quantity-by-day-last-month/${shopId}`;


// Table QR
export const TABLE_QRS = "/table-qrs";
export const TABLE_QR = (id: string | number) => `/table-qrs/${id}`;
export const RESOLVE_TABLE_QR = (token: string) => `/web/qr/${token}`;
export const VERIFY_TABLE_QR = "/table-qrs/verify";


// Shop members
export const SHOP_MEMBERS = "/users/shop-members";
export const SHOP_MEMBER = (userId: string | number) => `/users/shop-members/${userId}`;

export const CREATE_SUBSCRIPTION_PAYMENT = '/payment/create';
export const PAYMENT_STATUS_BY_ID = (paymentTransactionId: string | number) => `/payment/status/${paymentTransactionId}`;
